<template>
  <NuxtLink
    :to="resolveLocalePath(category.link)"
    :class="bem()"
  >
    <div :class="bem('icon-wrapper')">
      <img
        class="w-14 h-14"
        :src="`https://intercom.help/sungod/assets/svg/icon:${category.icon}/3449B8`"
        alt=""
        width="100%"
        height="100%"
        loading="lazy"
      >
    </div>

    <div :class="bem('copy')">
      <VisionHeading
        tag="h4"
        size="h4"
        :class="bem('heading')"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="category.label || category.name" />
      </VisionHeading>
      <p
        v-if="category.childArticleCount"
        :class="bem('count')"
      >
        {{ category.childArticleCount }} {{ $trp('article', 'articles', category.childArticleCount) }}
      </p>
    </div>
  </NuxtLink>
</template>

<script setup>
const bem = useBEM('SupportTopLevelCategory')
const { resolveLocalePath } = useUrlBuilder()

defineProps({
  category: { type: Object, required: true }
})
</script>

<style lang="postcss">
.SupportTopLevelCategory {
  @apply transition ease-linear grow overflow-hidden
    border border-solid border-gray-200
    shadow-sm
    rounded-md
    no-underline
    flex-col;

  &:hover {
    @apply border-purple/50;

    .SupportTopLevelCategory__heading {
      @apply t-gradient;
    }
  }

  &__copy {
    @apply flex w-full flex-1 flex-col
      justify-between px-6 py-4;
  }

  &__heading {
    @apply flex justify-center text-center transition ease-linear
      line-clamp-2 sm:line-clamp-1;
  }

  &__count {
    @apply mt-4 flex justify-center line-clamp-1
      text-sm text-gray-500;
  }

  &__icon-wrapper {
    @apply flex items-center justify-center bg-cover bg-center px-3 py-10 pb-2 pt-10;
  }
}
</style>
